export const RECOMMENDED_PARTNER_VIDEO_HEIGHT = 480

export const ADD_PARTNER_MODAL_ID = 'AddPartnerModal'

export const PARTNER_COLUMN_GAP = 16

export const PARTNER_COLUMN_WIDTH = 245

export const PROFESSIONAL_NETWORK_BOARD_DOM_ID = 'js-professional-network-board'
